module.exports = __webpack_public_path__ + "img/HealedBone.ffb5e631.png";